import React, { useEffect, useState } from "react";
import product4 from "../../assets/images/product4.png";
import FetchData, { GetList } from "../../providers/dataProvider";
import { ProductCategoryBrowser } from "./ProductCategoryBrowser";

export const MainCategory = ({ setProductTab }) => {
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [listData, setListData] = useState([]);
  const { data: productfamily, loading: productfamilyLoading } = FetchData("productfamily");

  useEffect(() => {
    if (productfamily) {
      setCategories(productfamily);
    }
  }, [productfamily]);

  useEffect(() => {
    if (listData?.data) {
      setCategories(listData.data);
    }
  }, [listData]);

  const handleSearch = () => {
    if (search.trim() !== "") {
      GetList("searchproduct", { search: search.trim() }, setListData);
    } else {
      setCategories(productfamily || []);
    }
  };

  const handleClearSearch = () => {
    setSearch("");
    setCategories(productfamily || []);
  };

  const handleBack = () => {
    setProductTab({ tab: "ProductList", id: 0 });
  };

  const handleSelect = (item) => {
    if (item?.hasOwnProperty("productName")) {
      setProductTab({
        tab: "ProductQuotation",
        id: item,
        subCategoryId: item?.productGroupId,
        productSubCategoryId: item?.productGroupId,
        title: item?.shortDesc,
        redirectTab: "MainCategory",
      });
    } else {
      setProductTab({ tab: "SubCategory", subCategoryId: item?.id });
    }
  };

  return (
    <ProductCategoryBrowser
      title="Select Main Category"
      search={search}
      items={categories}
      loading={productfamilyLoading}
      fallbackImage={product4}
      onBack={handleBack}
      onSearch={handleSearch}
      onSearchChange={setSearch}
      onClearSearch={handleClearSearch}
      onSelect={handleSelect}
    />
  );
};
